// index.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'

import { externalNewsletterDispatchers as dispatchers } from 'reduxModules/users/dispatchers'
import { externalNewsletterReselector as stateSelector } from 'reduxModules/users/selectors'

import RenderField from '../../generic/RenderedField'
import { validators } from '../../../redux/modules/utils/forms'

import './styles.css'

function ExternalEmailFunnelDialog({
  isPopUp,
  handleSubmit,
  tag,
  pristine,
  invalid
}) {
  return (
    <section id="ExternalEmailFunnelDialog" className={isPopUp ? 'popup' : ''}>
      <div className="internal-container wrapper">
        <div className="copy">
          <h2 className="title">Enjoying our courses?</h2>
          <div className="subtitle">
            <p className="tagline">
              Join our Newsletter for updates about new courses, artists, and
              student contests!
            </p>
          </div>
        </div>

        <div className="form">
          <form onSubmit={handleSubmit}>
            <Field
              name="email"
              validate={validators.email}
              component={RenderField}
              type="email"
              placeholder="Email"
              props={{ ariaLabel: 'Email' }}
              key={`${tag}-email-field`}
            />

            <button
              type="submit"
              className="btn -wide -blue-2"
              disabled={pristine || invalid}
              aria-label="Enter your email and click submit to receive your free content"
            >
              Sign Me Up
            </button>
          </form>
        </div>
      </div>
    </section>
  )
}

ExternalEmailFunnelDialog.propTypes = {
  tag: PropTypes.string.isRequired,
  isPopUp: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  formValues: PropTypes.object,
  toggleNewsletter: PropTypes.func,
  pristine: PropTypes.bool
}

ExternalEmailFunnelDialog.defaultProps = {
  isPopUp: false
}

const Wrapped = reduxForm({
  form: 'external-email-funnel'
})(ExternalEmailFunnelDialog)

export default connect(stateSelector, dispatchers)(Wrapped)
